/**
 * Formats a numeric value for display.
 * Numbers under 100,000 display with comma separators (e.g., 99,999).
 * Larger numbers are abbreviated with K/M/B suffix (e.g., 123.5K, 1.2M, 1.2B).
 *
 * @example
 * formatNumericValue(1000)      // "1,000"
 * formatNumericValue(99999)     // "99,999"
 * formatNumericValue(123456)    // "123.5K"
 * formatNumericValue(1234567)   // "1.2M"
 * formatNumericValue(1234567890) // "1.2B"
 */
export function formatNumericValue(value: number): string {
  if (value < 100_000) {
    return value.toLocaleString("en-US")
  }
  return value.toLocaleString("en-US", {
    maximumFractionDigits: 1,
    notation: "compact",
    compactDisplay: "short"
  })
}
